<template>
  <div class="min-h-screen bg-gray-50 flex flex-col">
    <!-- Header Section -->
    <header class="bg-indigo-700 text-white py-16 px-6 text-center relative overflow-hidden">
      <div class="absolute inset-0 bg-grid-white/10 opacity-20"></div>
      <div class="relative z-10 max-w-4xl mx-auto">
        <h1 class="text-4xl md:text-5xl font-bold mb-4">Delete Your Account</h1>
        <p class="text-lg text-blue-100 max-w-2xl mx-auto">We’re sorry to see you go.</p>
      </div>
    </header>

    <main class="max-w-4xl mx-auto px-6 pb-16 text-gray-700 pt-8">
      <div class="bg-white rounded-lg shadow-sm p-6 md:p-8 mb-8">
        <p class="text-gray-600 mb-6">
          If you’d like to permanently delete your account, please follow these steps:
        </p>

        <ol class="list-decimal list-inside space-y-3 text-gray-700">
          <li>Open the app or website and make sure you’re signed in to your account.</li>
          <li>Go to Account &gt; Delete Account.</li>
          <li>Confirm your request by following the on-screen instructions.</li>
          <li>Once confirmed, your account will be permanently removed from our system.</li>
        </ol>

        <div class="mt-6 text-gray-600">
          <p>If you experience any issues during this process, please contact our support team at <a href="mailto:support@example.com" class="text-blue-600">support@example.com</a> for assistance.</p>
        </div>

      </div>

      <div class="bg-white rounded-lg shadow-sm p-6 md:p-8">
        <h2 class="text-lg font-semibold mb-2 text-gray-800">⚠️ Warning</h2>
        <p class="text-gray-600">User data is automatically deleted within 90 days after the account deletion request is submitted.</p>
      </div>
    </main>

    <!-- Footer -->
    <footer class="bg-white border-t border-gray-200 py-6 mt-auto">
      <div class="max-w-4xl mx-auto px-6 text-center text-gray-500 text-sm">
        <p>If you need more help, contact support.</p>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'DeleteAccount'
}
</script>

<style scoped>
:deep(.prose a) {
  color: #3b82f6;
  text-decoration: none;
  font-weight: 500;
}

:deep(.prose a:hover) {
  text-decoration: underline;
}
</style>
